import hero from "../../../Assets/img/bg-hero-pymes-desktop.png";
import figura10 from "../../../Assets/img/figura10.svg";
import Asesoramiento from '../Components/Asesoramiento';
import { TestimoniosSlider } from '../Components/TestimoniosSlider';
import { pymes_coberturas, testimonios_clientes } from "../diccionario";
import PropuestaValor from "../Components/PropuestaValor";
import { useRef } from "react";
import useSEOConfig from "../../../hooks/seo/useSEOConfig";
import { Navbar } from "../Components/Navbar";
import { PorQueElegirnos } from "../Components/PorQueElegirnos";
import styled from "@emotion/styled";
import { useConfig } from "../../../context/ConfigContext";
import { Link, useLocation } from "react-router-dom";
import { buscarTextoSeo } from "../../../utils/buscarTextoSeo";

const IconContainer = styled.span<any>`
  color: ${({ color }) => color} !important;
 &:hover{
    background: ${({ color }) => color} !important;
    color: white !important;
 }   
`;
export const Pymes = () => {
    const targetRef = useRef<HTMLDivElement>(null);
    const { origen: parametros, config } = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);

    const riesgos = (parametros!.origen === "SEGURARSE") ?
        pymes_coberturas.filter(cob => cob.pais.includes(config.pais)) :
        parametros!.riegos;
    const handleScrollToElement = () => {
        const isMobile = window.innerWidth <= 768;

        targetRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: isMobile ? 'start' : 'center',
        });
    };

    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ??
            (config.pais === "UY" ?
            "Conocé la amplia variedad de seguros que tenemos para proteger tu negocio · ART · Seguro Integral de Comercio · Seguro de Vida Colectivo · Caución · Todo Riesgo Operativo · Industrias"
            :
            "Conocé la amplia variedad de seguros que tenemos para proteger tu negocio · ART · Seguro Integral de Comercio · Seguro de Vida Colectivo · Caución · Todo Riesgo Operativo · Agro · Industrias "),
            tituloCompleto: !!textoSeo,
            keywords:
            config.pais === "UY" ?
            "Seguros de Vida Colectivos, Garantía de Caución, Seguro Integral de Comercio, Seguros para empresas, Seguros para comercios, Contratar ART online, Cotizar Seguro de caución, Seguros Integral de Consorcio, Seguros para locales comerciales, Seguros para Pymes"
            :
            "Seguros de Vida Colectivos, Garantía de Caución, Seguro Integral de Comercio, Seguros para empresas, Seguros para comercios, Contratar ART online, Cotizar Seguro de caución, Empresas de asistencia al viajero, Seguros Integral de Consorcio, Seguros para locales comerciales, Seguros para Pymes",
            ogTitle: 
            config.pais === "UY" ?
            "Segurarse - Corredor de Seguros digital"
            :
            "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros Corporativos a medida de tu empresa. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
            twitterDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros Corporativos a medida de tu empresa. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!"
        }
    )

    return (
        <>
            <Navbar rubro='auto' />
            <main className="bg-white">
                <div className="overflow-hidden pb-lg-20">
                    <div
                        className={parametros!.origen === "SEGURARSE" ? "bg-primary" : ""}
                        style={parametros!.origen !== "SEGURARSE" ? { background: parametros!.bgColor } : {}}>
                        <div className="container-lg pt-40 pb-280 px-20 px-lg-12 position-relative bg-hero-pymes z-1">
                            <div className="d-flex flex-column flex-lg-row">

                                <div className="col-10 col-sm-8 col-lg-9 col-xl-7">
                                    <h1 className="ff-mukta fw-bold fs-30 fs-lg-50 lh-11 text-white mb-25 mb-lg-32">Buscamos tu tranquilidad y la seguridad de tu negocio.</h1>

                                    <p className="fs-16 fs-lg-20 lh-12 text-white mb-22 mb-lg-32">Te acompañamos en el crecimiento de tu PyME.<br />
                                        <br className="d-lg-none" />Contratá seguros a medida y protegé tu inversión de todo riesgo.</p>
                                    <button onClick={handleScrollToElement} className="transition-base d-inline-block w-180p w-lg-235p py-10 py-lg-3 rounded-2 fs-15 fs-lg-22 fw-bold lh-1 text-center bg-white text-primary" style={{ border: "none" }}>
                                        Asegurá tu PyME
                                    </button>
                                </div>

                                <div className="d-none d-lg-block fig-position-individuos">
                                    <img className="img-fluid" src={hero} alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {parametros!.origen !== "SEGURARSE" &&
                    <div className="pt-50 pb-30 pt-lg-40 pb-lg-0" ref={targetRef} id="coberturas" >
                        <div className="container" >
                            <div className="col-10 mx-auto" >
                                <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black text-center mb-30 mb-lg-35">Coberturas para todos los riesgos</h2>
                            </div>
                            <div className="d-flex flex-wrap column-gap-md-3 row-gap-30p justify-content-center mx-auto text-center" >
                                {
                                    riesgos.map(item => (
                                        <a key={item.label} className="item-seguro-alt" href={item.link}>
                                            <IconContainer
                                                color={parametros?.bgColor}
                                                className="icon-seguros-alt-wrapper">
                                                <svg className="svg-icon icon-seguros-alt"
                                                ><use xlinkHref={item.icon}></use></svg>
                                            </IconContainer>
                                            <span className="d-block fs-13 lh-1 fw-bold text-black">{item.label}</span>
                                        </a>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                }

                <PorQueElegirnos color={parametros!.bgColor} />

                <PropuestaValor origen={parametros!.origen} color={parametros?.bgColor} />

                {parametros!.origen === "SEGURARSE" &&
                    <>
                        <div className="pt-50 pb-30 pt-lg-40 pb-lg-4" ref={targetRef} id="coberturas" >
                            <div className="container" >
                                <div className="col-10 mx-auto" >
                                    <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black text-center mb-30 mb-lg-35">Coberturas para todos los riesgos</h2>
                                </div>
                                <div className="d-flex flex-wrap column-gap-md-3 row-gap-30p justify-content-center mx-auto text-center" >
                                    {
                                        riesgos.map(item => (
                                            <Link key={item.label} className="item-seguro-alt" to={item.link}>
                                                <IconContainer
                                                    color={parametros?.bgColor}
                                                    className="icon-seguros-alt-wrapper">
                                                    <svg className="svg-icon icon-seguros-alt"
                                                    ><use xlinkHref={item.icon}></use></svg>
                                                </IconContainer>
                                                <span className="d-block fs-13 lh-1 fw-bold text-black">{item.label}</span>
                                            </Link>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            config.pais === "AR" &&
                            <Asesoramiento background="white" wppUrl="Hola! Quiero cotizar un seguro corporativo"/>
                        }
                    </>
                }


                <div className="bg-f3 py-45" style={{ paddingBottom: "68px" }}>
                    <div className="container">

                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black mb-30 mb-lg-40 text-center">Nuestros <br className="d-md-none" /> clientes dicen...</h2>

                        <div className="row mb-50 align-items-center">
                            <div className="col-md-4">
                                <p className="d-flex flex-column flex-xxl-row align-items-center mb-22 text-center text-xxl-start">
                                    <span className="fs-52 fw-bold text-primary lh-1 d-inline-flex align-items-center me-xl-3">85.4%</span>
                                    <span className="fs-18 text-black lh-11">Están <b>muy satisfechos</b><br /> con el servicio recibido</span>
                                </p>
                            </div>
                            <div className="col-md-4">
                                <p className="d-flex flex-column flex-xxl-row align-items-center mb-22 text-center text-xxl-start">
                                    <span className="fs-52 fw-bold text-primary lh-1 d-inline-flex align-items-center me-xl-3">8 <span className="w-40p ms-2 me-1 fs-15 fw-bold text-start">de cada</span> 10</span>
                                    <span className="fs-18 text-black lh-11"><b>Recomendarían</b><br /> Segurarse</span>
                                </p>
                            </div>
                            <div className="col-md-4">
                                <p className="d-flex flex-column flex-xxl-row align-items-center mb-22 text-center text-xxl-start">
                                    <span className="fs-52 fw-bold text-primary lh-1 d-inline-flex align-items-center me-xl-3">9 <span className="w-40p ms-2 me-1 fs-15 fw-bold text-start">de cada</span> 10</span>
                                    <span className="fs-18 text-black lh-11"><span>Reconocen el <b>profesionalismo</b><br /> del ejecutivo a cargo</span>
                                    </span></p>
                            </div>
                        </div>

                        <TestimoniosSlider testimonios={testimonios_clientes} />
                    </div>
                </div>
            </main>
        </>
    )
}